import { render } from "./tags.vue?vue&type=template&id=367d24d4&ts=true"
import script from "./tags.vue?vue&type=script&lang=ts"
export * from "./tags.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__